module.exports = __webpack_public_path__ + "static/media/tracking.2a20fc0c.jpg";